import React, { useEffect, useState } from "react";
import { FileText, Download, Gift } from "lucide-react";
import Layout from "@/components/Layout";
import { api, API, resolveImage } from "@/lib/api";

export default function FreePdfs() {
  const [list, setList] = useState(null);

  useEffect(() => {
    api.get("/pdfs/free").then((r) => setList(r.data)).catch(() => setList([]));
  }, []);

  return (
    <Layout>
      <div className="px-4 pt-6 pb-8">
        <h1 className="font-heading font-black text-3xl sm:text-4xl text-brand-blue">PDF gratuiti</h1>
        <p className="text-sm text-slate-500 mt-2 max-w-xl">
          Scarica liberamente guide, cataloghi e schede da collezione. Nessuna registrazione richiesta.
        </p>
        <div className="mt-4 inline-flex items-center gap-2 bg-brand-yellow/20 text-brand-blue rounded-full px-4 py-2 text-xs font-bold">
          <Gift className="w-4 h-4" /> Con ogni ordine di giocattoli ricevi anche 1 PDF in omaggio
        </div>

        {list === null ? (
          <p className="mt-8 text-slate-500 text-sm">Caricamento...</p>
        ) : list.length === 0 ? (
          <p className="mt-8 text-slate-500 text-sm" data-testid="free-pdfs-empty">Al momento non ci sono PDF gratuiti disponibili.</p>
        ) : (
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="free-pdfs-grid">
            {list.map((p) => (
              <div key={p.id} data-testid={`free-pdf-${p.id}`} className="bg-white border border-border rounded-2xl overflow-hidden flex flex-col hover:-translate-y-0.5 transition-transform">
                <div className="aspect-[3/4] bg-slate-100 flex items-center justify-center">
                  {p.cover_url ? <img src={resolveImage(p.cover_url)} alt={p.title} className="w-full h-full object-cover" /> : <FileText className="w-12 h-12 text-brand-blue/40" />}
                </div>
                <div className="p-3 flex-1 flex flex-col">
                  <div className="font-heading font-bold text-sm text-slate-900 line-clamp-2">{p.title}</div>
                  {p.description && <p className="text-xs text-slate-500 mt-1 line-clamp-3">{p.description}</p>}
                  <a
                    href={`${API}/pdfs/${p.id}/download`}
                    data-testid={`free-pdf-download-${p.id}`}
                    className="mt-3 h-10 rounded-full bg-brand-yellow hover:bg-brand-yellow-dark text-brand-blue text-xs font-bold inline-flex items-center justify-center gap-1"
                  >
                    <Download className="w-4 h-4" /> Scarica gratis
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
